import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import DocumentIconCounter from "components/common/DocumentIconCounter.jsx";

export const PayCell = (props) => {
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  return (
    <td
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
      }}
      {...navigationAttributes}
    >
      {props.dataItem.payee || props.dataItem.payer}
    </td>
  );
};

export function createBatchPostingCommandCell({ onEdit, onRemove }) {
  return function BatchPostingCommandCell(props) {
    return (
      <td style={{ display: "flex", flexDirection: "column" }}>
        <button
          type="button"
          onClick={() => onEdit(props)}
          className="k-button k-button-md k-rounded-md "
        >
          <AiOutlineEdit color="blue" />
        </button>

        <button
          type="button"
          style={{ marginTop: "5px" }}
          onClick={() => onRemove(props.dataIndex)}
          className="k-button k-button-md k-rounded-md "
        >
          <AiOutlineDelete color="red" />
        </button>
      </td>
    );
  };
}

function getDocumentCount(dataItem) {
  if (dataItem.documentCount !== undefined && dataItem.documentCount !== null) {
    return Number(dataItem.documentCount);
  }
  if (Array.isArray(dataItem.documentFiles)) {
    return dataItem.documentFiles.length;
  }
  return 0;
}

export function createBatchPostingDocumentCounterCell({ onViewDocuments }) {
  return function BatchPostingDocumentCounterCell(e) {
    return (
      <td className="px-0">
        <DocumentIconCounter
          count={getDocumentCount(e.dataItem)}
          onClick={() => onViewDocuments(e.dataItem)}
        />
      </td>
    );
  };
}
